import { useQuery } from '@tanstack/react-query';

import { getManagerContext } from '@/features/auth/api/managerContext';

export const managerContextQueryKey = ['manager-context'] as const;

export function useManagerContext() {
  return useQuery({
    queryKey: managerContextQueryKey,
    queryFn: getManagerContext,
    retry: false,
    staleTime: 5 * 60_000,
  });
}
